import {PureComponent} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import { fetchQuery } from 'Util/Request';
import RetryPayuPage from "./RetryPayuPage.component";
import CheckoutQuery from 'Query/Checkout.query';
import OrderQuery from 'Query/Order.query';
import { showNotification } from 'Store/Notification/Notification.action';
import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { getIndexedProducts } from 'Util/Product';
import * as Sentry from "@sentry/react";

export const mapDispatchToProps = (dispatch) => ({
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    getOrder: (orderId) => OrderDispatcher.then(({ default: dispatcher }) => dispatcher.getOrderById(dispatch, orderId)),
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
});

export class RetryPayuPageContainer extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            payu: '',
            isLoading: true,
            isOrderAllowed: false,
            order: {}
        }
    }

    containerFunctions = {
        onProcessRetryPayment: this.processRetryPayment.bind(this)
    };

    componentDidMount() {
        const {match} = this.props;
        const {id, code} = match.params;
        const { toggleBreadcrumbs } = this.props;
        toggleBreadcrumbs(false);
        this.requestOrderDetails(id, code);
    }

    requestOrderDetails(orderId, ctrl) {
        fetchQuery(OrderQuery.getOrderByIdCtrlQuery(orderId, ctrl)).then(
            ({ getOrderByIdCtrl: rawOrder }) => {
                const { order_products = [] } = rawOrder;
                const indexedProducts = getIndexedProducts(order_products);
                const order = { ...rawOrder, order_products: indexedProducts };
                this.setState({ order, isLoading: false, isOrderAllowed: true });
            },
            (error) => {
                // TODO add sentry error details
                showNotification('error', __('Payment link is no longer valid or an error occurred'));
                Sentry.captureException(error);
                this.setState({ isLoading: false, isOrderAllowed: false });
            }
        );
    }

    async processRetryPayment() {
        const {match} = this.props;
        const {order, code} = match.params;

        await fetchQuery(CheckoutQuery.getRetryPayu(order, code)).then(
            ({getRetryPayuData: {payu_json}}) => {
                this.setState({payu: payu_json});
            },
            (error) => {
                Sentry.captureException(error);
            }
        );

        document.getElementById('payu').submit();
    }


    render() {
        return <RetryPayuPage { ...this.state } {...this.containerFunctions}/>;
    }
}

export default withRouter(connect(null, mapDispatchToProps)(RetryPayuPageContainer));
